export const firebaseConfig = {
    apiKey: "AIzaSyCzYDz-hlXTZBaIPYt7BVS1nAtv8BRSo_w",
    authDomain: "newro.co.za",
    projectId: "move-743b4",
    storageBucket: "move-743b4.firebasestorage.app",
    messagingSenderId: "84269359835",
    appId: "1:84269359835:web:1cb18b69614faf5926a2fe",
    measurementId: "G-Q9YVDZK1ML"
};